import React from 'react';
import { CTContainer } from '../styles';

interface ITopCTA {
  onClickCB: (e: React.MouseEvent<Element>) => void;
  CTA: string;
}
export const TopCTA: React.FC<ITopCTA> = ({ onClickCB, CTA }) => {
  return (
    <CTContainer>
      <div
        onClick={onClickCB}
        data-testid="topCta"
        dangerouslySetInnerHTML={{ __html: CTA || '' }}
      />
    </CTContainer>
  );
};
